export default __webpack_public_path__ + "static/poster-education-b6c27caeb513fc79871d23972195d854.jpg";